/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/**
 * PH2 booking links.
 *
 * BOOK_URL is the one place that decides where every "Book Now" goes.
 * 1. Old picture buttons that link to the Contact page are replaced with the standard
 *    call to action: "Schedule your free consult today" plus a Book Now button.
 * 2. Every link on the site that points to the old Book Your Appointment page
 *    (the homepage hero button, the Results page button, and so on) is pointed at BOOK_URL.
 * Booking opens in a new tab so the visitor keeps the site open.
 */
(function () {
  var BOOK_URL = 'https://calendly.com/kevin-ph2nutrition/30min';
  var OLD_BOOKING_PATH = '/pages/book-your-appointment';

  var style = document.createElement('style');
  style.textContent =
    'a[href$="/pages/contact"] img[src*="CALIFORNIA_LIGHTWORKS"]{visibility:hidden}' +
    '.ph2-cta{text-align:center;margin:32px 0}' +
    '.ph2-cta--left{text-align:left;margin:20px 0 0}' +
    '.ph2-cta__label{margin:0 0 14px;font-size:14px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;color:#111}';
  document.head.appendChild(style);

  function pointToBooking(link) {
    link.href = BOOK_URL;
    link.target = '_blank';
    link.rel = 'noopener';
  }

  function buildCta(extraClass) {
    var wrap = document.createElement('div');
    wrap.className = 'ph2-cta' + (extraClass ? ' ' + extraClass : '');
    var label = document.createElement('p');
    label.className = 'ph2-cta__label';
    label.textContent = 'Schedule your free consult today';
    var btn = document.createElement('a');
    btn.className = 'Button Button--primary';
    btn.textContent = 'Book Now';
    pointToBooking(btn);
    wrap.appendChild(label);
    wrap.appendChild(btn);
    return wrap;
  }

  function swap() {
    var imgs = document.querySelectorAll('a[href$="/pages/contact"] img[src*="CALIFORNIA_LIGHTWORKS"]');
    Array.prototype.forEach.call(imgs, function (img) {
      var link = img.closest('a');
      var p = link.closest('p');
      var block = (p && !p.textContent.trim()) ? p : link;
      block.parentNode.replaceChild(buildCta(), block);
    });

    // Homepage "Consult" button beside the video.
    var consult = document.querySelectorAll('.homepage-kevin a.Button[href="/pages/contact"]');
    Array.prototype.forEach.call(consult, function (a) {
      a.parentNode.replaceChild(buildCta('ph2-cta--left'), a);
    });

    // Any remaining link to the old booking page goes to BOOK_URL instead.
    var oldLinks = document.querySelectorAll('a[href$="' + OLD_BOOKING_PATH + '"]');
    Array.prototype.forEach.call(oldLinks, pointToBooking);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swap);
  } else {
    swap();
  }
})();
